// src/components/AuditLogs/ToggleSwitch.jsx
import React from "react";
import styled from "styled-components";

const SwitchContainer = styled.div`
  display: flex;
  position: relative;
  width: 450px; /* 5 buttons at 90px each + padding */
  height: 40px;
  padding: 4px;
  align-items: center;
  border-radius: 100px;
  border: 1px solid #e9ecef;
  background: #f8f9fa;
`;

const SwitchButton = styled.button`
  flex: 1;
  height: 100%;
  background: transparent;
  border: none;
  color: ${({ $isActive }) => ($isActive ? "#161718" : "#6C757D")};
  font-size: 16px;
  font-weight: ${({ isActive }) => (isActive ? 600 : 400)};
  cursor: pointer;
  z-index: 2;

  &:focus {
    outline: none;
  }
`;

const ActiveIndicator = styled.div`
  position: absolute;
  top: 2px;
  left: ${({ $index }) => `calc((${$index} * 25%) + 2px)`};
  width: calc(25% - 4px);
  height: calc(100% - 4px);
  border-radius: 100px;
  background: #89dee4;
  transition: left 0.3s ease;
  z-index: 1;
`;

const labels = ["All", "System", "Care Plan", "Builder"];
const keys = ["all", "system", "carePlan", "builder"];

export default function ToggleSwitch({ activeTab, setActiveTab }) {
  const idx = keys.indexOf(activeTab);

  return (
    <SwitchContainer>
      <ActiveIndicator $index={idx} />
      {labels.map((label, i) => (
        <SwitchButton
          key={keys[i]}
          $isActive={activeTab === keys[i]}
          onClick={() => setActiveTab(keys[i])}
        >
          {label}
        </SwitchButton>
      ))}
    </SwitchContainer>
  );
}
